import React from "react"
import { connect } from "react-redux"
import SymptomBubble from "./SymptomBubble"
import SearchBubble from "./SearchBubble"
import FilterBubble from "../../filters"
import ClarifierBubble from "../../filters/components/ClarifierBubble"
import styled from "styled-components"

const Container = styled.div`
  display: ${props => (props.hide ? "none" : "inline-flex")};
  align-items: flex-end;
  flex-direction: column;
  width: 100%;
`

const hide = (item, chatItems, activeIndex, finished) => {
  if (item.embedded) {
    return chatItems[activeIndex].type === "symptomBubble" && !item.finished
  }

  return (
    (item.finished &&
      item.index !== chatItems.findIndex(i => i.type === "symptomBubble")) ||
    (!item.finished && finished)
  )
}

const SymptomBubbleWrapper = ({
  item,
  chatItems,
  activeIndex,
  loading,
  completed,
  finished,
  customSymptom,
  simpleFlowActive,
  simpleFlowInterviewType
}) => (
  <Container
    className="symptom-bubble-container"
    id={`symptom-bubble-container-${item.index}`}
    hide={hide(item, chatItems, activeIndex, finished)}
  >
    {symptomBubbleState(
      item,
      chatItems,
      activeIndex,
      loading,
      completed,
      finished,
      customSymptom,
      simpleFlowActive,
      simpleFlowInterviewType
    )}
  </Container>
)

const symptomBubbleState = (
  item,
  chatItems,
  activeIndex,
  loading,
  completed,
  finished,
  customSymptom,
  simpleFlowActive,
  simpleFlowInterviewType
) => {
  let currType = chatItems[activeIndex].type
  let isFilter = chatItems[activeIndex].filter
  let validState = !finished || activeIndex < finished
  let index = item.index

  if (item.finished) {
    if (index === chatItems.findIndex(i => i.type === "symptomBubble")) {
      return (
        <SymptomBubble
          {...item}
          completed={completed}
          customSymptom={customSymptom}
          showDelete={!simpleFlowInterviewType}
        />
      )
    } else {
      return <div />
    }
  }

  if (currType === "clarifier" && validState) {
    return (
      <ClarifierBubble
        item={chatItems[activeIndex]}
        index={index}
        customSymptom={customSymptom}
      />
    )
  }

  if (isFilter && validState) {
    return <FilterBubble index={index} customSymptom={customSymptom} />
  }

  if (
    currType !== "question" &&
    currType !== "response" &&
    !completed &&
    validState &&
    !simpleFlowActive
  ) {
    return <SearchBubble first={item.first} />
  }

  return <div />
}

const mapStateToProps = (state, ownProps) => ({
  item: ownProps.item,
  loading: state.loading,
  chatItems: state.chatList.items,
  activeIndex: state.chatList.active,
  completed: ownProps.completed || state.completion.completed,
  finished: state.search.finished,
  customSymptom: state.custom.symptom,
  // This flag only remains true while simpleFlow is being interacted with
  simpleFlowActive: state.simpleFlow.active,
  // This flag is maintained for the entire interview
  simpleFlowInterviewType: state.simpleFlow.diagnosis !== ""
})

const SymptomBubbleContainer = connect(mapStateToProps)(SymptomBubbleWrapper)

export { SymptomBubbleContainer as default }



// WEBPACK FOOTER //
// ./assets/search/components/SymptomBubbleContainer.js